import { render, staticRenderFns } from "./ReviewAskDialog.vue?vue&type=template&id=316bf508&scoped=true"
import script from "./ReviewAskDialog.vue?vue&type=script&lang=js"
export * from "./ReviewAskDialog.vue?vue&type=script&lang=js"
import style0 from "./ReviewAskDialog.vue?vue&type=style&index=0&id=316bf508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316bf508",
  null
  
)

/* custom blocks */
import block0 from "./ReviewAskDialog.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports